import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import NoTicketsImg from 'src/assets/no-tickets.svg';
import EmptyState from 'src/components/ui/EmptyState/EmptyState';
import PageHeader from 'src/components/ui/PageHeader/PageHeader';
import TicketItem from 'src/components/ui/TicketItem/TicketItem';
import TicketMap from 'src/components/ui/TicketMap/TicketMap';
import { routes } from 'src/routes';
import {
  getPriorityTickets,
  setPriorityTickets,
  setTicketList,
} from 'src/store/actions/ticketActions';
import { useLoadingSelector } from 'src/utils/useLoadingSelector';

import Statistics from '../../../ui/Statistics/Statistics';
import classes from './ManufacturerHome.module.scss';

const ManufacturerHome: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const priorityTickets = useAppSelector(
    (state) => state.ticket.priorityTickets
  );
  const priorityLoading = useLoadingSelector({
    actionType: getPriorityTickets.toString(),
  });

  useEffect(() => {
    dispatch(setTicketList({ count: 0, data: [], ctx: null }));
    dispatch(setPriorityTickets([]));
    dispatch(getPriorityTickets());
    return () => {
      dispatch(setTicketList({ count: 0, data: [], ctx: null }));
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.Container}>
      <PageHeader title={t('common:dashboard')} className={classes.Header} />
      <section>
        <h4>{t('dashboard:map_overview')}</h4>
        <TicketMap />
      </section>
      <section>
        <h4>{`${t('common:unassigned')} ${t(
          'common:tickets'
        ).toLowerCase()}`}</h4>
        <div>
          {!priorityLoading &&
            priorityTickets?.map((ticket, i) => (
              <TicketItem ticket={ticket} key={i} />
            ))}
          {priorityLoading &&
            [...Array(3)].map((_, i) => <TicketItem loading key={i} />)}
        </div>
        {!priorityTickets?.length && !priorityLoading ? (
          <EmptyState
            title={t('dashboard:no_unassigned')}
            subtitle={`${t('dashboard:no_unassigned_details')} ${t(
              'dashboard:no_unassigned_details_2'
            )}`}
            icon={NoTicketsImg}
          />
        ) : (
          <Link to={routes.TICKETS}>{t('dashboard:view_all_tickets')}</Link>
        )}
      </section>
      <section>
        <Statistics />
      </section>
      <section className={classes.ProductsSection}>
        <h4>{t('common:products')}</h4>
        <p>{t('dashboard:products_description')}</p>
        <Link to={routes.PRODUCTS} className={classes.Link}>
          {t('ticket_details:view_product_page')}
        </Link>
      </section>
    </div>
  );
};

export default ManufacturerHome;
